/**
 * @generated SignedSource<<1dc25c544e3980565ceb979097d0abc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ComponentType = "CHECKIN" | "HABIT" | "LESSON" | "MESSAGE" | "WORKOUT" | "%future added value";
export type CoachProgramComponentPreviewRouteQuery$variables = {
  componentSlug: string;
  programSlug: string;
};
export type CoachProgramComponentPreviewRouteQuery$data = {
  readonly component: {
    readonly id: string;
    readonly slug: string;
    readonly title: string;
    readonly type: ComponentType;
    readonly " $fragmentSpreads": FragmentRefs<"CoachComponent_component" | "RefreshSlug">;
  } | null | undefined;
  readonly program: {
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly weeks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly week: number;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CheckInAnswerProgressPhotoUpload_program" | "MediaElementPopover_program" | "RefreshSlug" | "WorkoutSectionElement_program">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ComponentLibraryAssetList_rootRef" | "ComponentTemplateDialog_rootRef" | "UnsplashImages_rootRef" | "useExerciseLibrary_rootRef">;
};
export type CoachProgramComponentPreviewRouteQuery = {
  response: CoachProgramComponentPreviewRouteQuery$data;
  variables: CoachProgramComponentPreviewRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "programSlug"
},
v2 = {
  "kind": "Variable",
  "name": "componentSlug",
  "variableName": "componentSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "programSlug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "after",
      "value": ""
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 9999
    }
  ],
  "concreteType": "WeeksConnection",
  "kind": "LinkedField",
  "name": "weeks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WeeksEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Week",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "week",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "weeks(after:\"\",first:9999)"
},
v8 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "RefreshSlug"
},
v9 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "componentSlug"
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "draft",
    "value": true
  }
],
v11 = {
  "alias": null,
  "args": (v10/*: any*/),
  "kind": "ScalarField",
  "name": "title",
  "storageKey": "title(draft:true)"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v21 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
],
v22 = {
  "kind": "Literal",
  "name": "assetType",
  "value": [
    "WORKOUT_EXERCISE"
  ]
},
v23 = [
  (v22/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Literal",
    "name": "includeShared",
    "value": true
  }
],
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomAssetsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomAsset",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      },
      (v17/*: any*/)
    ],
    "storageKey": null
  },
  (v20/*: any*/)
],
v25 = [
  (v22/*: any*/),
  (v13/*: any*/)
],
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    }
  ],
  "type": "Slug",
  "abstractKey": "__isSlug"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachProgramComponentPreviewRouteQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UnsplashImages_rootRef"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ComponentLibraryAssetList_rootRef"
      },
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ComponentTemplateDialog_rootRef"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useExerciseLibrary_rootRef"
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MediaElementPopover_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CheckInAnswerProgressPhotoUpload_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkoutSectionElement_program"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Component",
        "kind": "LinkedField",
        "name": "component",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "FragmentSpread",
            "name": "CoachComponent_component"
          },
          (v8/*: any*/),
          (v4/*: any*/),
          (v11/*: any*/),
          (v6/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CoachProgramComponentPreviewRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "CustomAssetsConnection",
        "kind": "LinkedField",
        "name": "custom_assets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomAssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomAsset",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assetType",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          (v20/*: any*/)
        ],
        "storageKey": "custom_assets(first:0)"
      },
      {
        "alias": null,
        "args": (v14/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ComponentLibraryAssetList_custom_assets",
        "kind": "LinkedHandle",
        "name": "custom_assets"
      },
      {
        "alias": null,
        "args": (v21/*: any*/),
        "concreteType": "ComponentTemplateConnection",
        "kind": "LinkedField",
        "name": "componentTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ComponentTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ComponentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "category",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "private",
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v21/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ComponentTemplateDialog_componentTemplates",
        "kind": "LinkedHandle",
        "name": "componentTemplates"
      },
      {
        "alias": "exercises",
        "args": (v23/*: any*/),
        "concreteType": "CustomAssetsConnection",
        "kind": "LinkedField",
        "name": "custom_assets",
        "plural": false,
        "selections": (v24/*: any*/),
        "storageKey": "custom_assets(assetType:[\"WORKOUT_EXERCISE\"],first:0,includeShared:true)"
      },
      {
        "alias": "exercises",
        "args": (v23/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ExerciseLibraryExercisesList_exercises",
        "kind": "LinkedHandle",
        "name": "custom_assets"
      },
      {
        "alias": "suggestedExercises",
        "args": (v25/*: any*/),
        "concreteType": "CustomAssetsConnection",
        "kind": "LinkedField",
        "name": "custom_assets",
        "plural": false,
        "selections": (v24/*: any*/),
        "storageKey": "custom_assets(assetType:[\"WORKOUT_EXERCISE\"],first:0)"
      },
      {
        "alias": "suggestedExercises",
        "args": (v25/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ExerciseAutocomplete_suggestedExercises",
        "kind": "LinkedHandle",
        "name": "custom_assets"
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Component",
        "kind": "LinkedField",
        "name": "component",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weekId",
            "storageKey": null
          },
          (v6/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "content",
            "storageKey": "content(draft:true)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "habitPrompt",
            "storageKey": "habitPrompt(draft:true)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "messageContent",
            "storageKey": "messageContent(draft:true)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "reminderType",
            "storageKey": "reminderType(draft:true)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "reminderTime",
            "storageKey": "reminderTime(draft:true)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "messageTime",
            "storageKey": "messageTime(draft:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "days",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "repeat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "image",
            "storageKey": "image(draft:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "locked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "kind": "ScalarField",
            "name": "teaser",
            "storageKey": "teaser(draft:true)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Program",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageURL",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "draftExists",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "utc",
                "value": true
              }
            ],
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": "updatedAt(utc:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iconName",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isComponentIcon"
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "544bf77837367b03848f00216000a079",
    "id": null,
    "metadata": {},
    "name": "CoachProgramComponentPreviewRouteQuery",
    "operationKind": "query",
    "text": "query CoachProgramComponentPreviewRouteQuery(\n  $programSlug: String!\n  $componentSlug: String!\n) {\n  ...ComponentLibraryAssetList_rootRef\n  ...ComponentTemplateDialog_rootRef_33N9e7\n  ...useExerciseLibrary_rootRef\n  program(slug: $programSlug) {\n    id\n    name\n    slug\n    weeks(first: 9999, after: \"\") {\n      edges {\n        node {\n          id\n          week\n        }\n      }\n    }\n    ...RefreshSlug\n    ...MediaElementPopover_program\n    ...CheckInAnswerProgressPhotoUpload_program\n    ...WorkoutSectionElement_program\n  }\n  component(slug: $componentSlug) {\n    ...CoachComponent_component_3CJfPz\n    ...RefreshSlug\n    id\n    title(draft: true)\n    slug\n    type\n  }\n}\n\nfragment ChangeComponentCoverDialog_component_3CJfPz on Component {\n  content(draft: true)\n  teaser(draft: true)\n  image(draft: true)\n  ...ComponentPreview_component_3CJfPz\n  program {\n    imageURL\n    id\n  }\n}\n\nfragment CheckInAnswerProgressPhotoUpload_program on Program {\n  id\n}\n\nfragment CoachComponentBar_component_3CJfPz on Component {\n  id\n  ...EditorMenu_component_3CJfPz\n  ...ComponentPublishButton_component\n  type\n  title(draft: true)\n  updatedAt(utc: true)\n}\n\nfragment CoachComponentTitle_component_3CJfPz on Component {\n  ...ComponentIcon_component\n  ...SelectComponentIcons_component\n  type\n  title(draft: true)\n}\n\nfragment CoachComponent_component_3CJfPz on Component {\n  id\n  weekId\n  slug\n  type\n  status\n  title(draft: true)\n  content(draft: true)\n  habitPrompt(draft: true)\n  messageContent(draft: true)\n  reminderType(draft: true)\n  reminderTime(draft: true)\n  messageTime(draft: true)\n  days\n  repeat\n  duration\n  ...CoachComponentBar_component_3CJfPz\n  ...ComponentPublishButton_component\n  ...CoachComponentTitle_component_3CJfPz\n  ...ComponentIcon_component\n}\n\nfragment ComponentIcon_component on ComponentIcon {\n  __isComponentIcon: __typename\n  iconName\n  type\n}\n\nfragment ComponentLibraryAssetList_rootRef on Root {\n  custom_assets(first: 0) {\n    edges {\n      node {\n        id\n        ...ComponentLibraryAsset_asset\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ComponentLibraryAsset_asset on CustomAsset {\n  id\n  assetType\n  content\n}\n\nfragment ComponentPreview_component_3CJfPz on Component {\n  title(draft: true)\n  teaser(draft: true)\n  image(draft: true)\n  ...ComponentIcon_component\n}\n\nfragment ComponentPublishButton_component on Component {\n  status\n  draftExists\n  type\n}\n\nfragment ComponentTemplateDialog_rootRef_33N9e7 on Root {\n  componentTemplates(first: 99, componentSlug: $componentSlug) {\n    edges {\n      node {\n        ...ComponentTemplateLibrary_template\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n\nfragment ComponentTemplateLibrary_template on ComponentTemplate {\n  id\n  title\n  category\n  private\n}\n\nfragment EditorMenu_component_3CJfPz on Component {\n  id\n  type\n  title(draft: true)\n  content(draft: true)\n  habitPrompt(draft: true)\n  image(draft: true)\n  locked\n  ...ChangeComponentCoverDialog_component_3CJfPz\n}\n\nfragment ExerciseAutocomplete_rootRef on Root {\n  suggestedExercises: custom_assets(first: 0, assetType: [WORKOUT_EXERCISE]) {\n    edges {\n      node {\n        id\n        name\n        content\n        userId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ExerciseLibraryExercise_asset on CustomAsset {\n  id\n  name\n  content\n  userId\n}\n\nfragment ExerciseLibraryExercisesList_rootRef on Root {\n  exercises: custom_assets(first: 0, assetType: [WORKOUT_EXERCISE], includeShared: true) {\n    edges {\n      node {\n        id\n        ...ExerciseLibraryExercise_asset\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaElementPopover_program on Program {\n  id\n}\n\nfragment RefreshSlug on Slug {\n  __isSlug: __typename\n  slug\n  slugId\n}\n\nfragment SelectComponentIcons_component on Component {\n  id\n  iconName\n  type\n}\n\nfragment WorkoutSectionElement_program on Program {\n  id\n}\n\nfragment useExerciseLibrary_rootRef on Root {\n  ...ExerciseLibraryExercisesList_rootRef\n  ...ExerciseAutocomplete_rootRef\n}\n"
  }
};
})();

(node as any).hash = "c161c3b835ce1911170015b9605e1639";

export default node;
